
            const data = {"name":"filter","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M7 11h10v2H7v-2ZM4 7h16v2H4V7Zm6 8h4v2h-4v-2Z\" _fill=\"#909090\"/>","originalColors":[{"type":"fill","color":"#909090"}],"stopColors":[]}}
        
                    module.exports = data
                    